import usePostListMenu, { ActivePostPage } from '@/composables/ui/postListMenu'
import usePostsLoader from '@/composables/post/postLoader'
import useAppState from '@/composables/ui/ui'
import usePostList from '@/composables/post/postList'
import { Post } from '@/model/data-object/Post'

export default function usePostCreate() {
  const { showPost, clearListData } = usePostsLoader()
  const {
    lastSavedPost,
    postIdToShow,
    showLastSavedPost,
    refreshInitTime,
  } = useAppState()
  const { activePage } = usePostListMenu()

  const createdPostBottom = async () => {
    if (
      [
        ActivePostPage.Best,
        ActivePostPage.Show,
        ActivePostPage.Newest,
        ActivePostPage.Oldest,
      ].includes(activePage.value)
    ) {
      if (lastSavedPost.value) {
        clearListData()
        postIdToShow.value = lastSavedPost.value.id
        if (activePage.value === ActivePostPage.Show) {
          showPost(postIdToShow.value)
        }
      }
      refreshInitTime()
    }
  }

  const showAfterCreate = () => {
    if (lastSavedPost.value) {
      postIdToShow.value = lastSavedPost.value.id
      if (activePage.value === ActivePostPage.Show) {
        clearListData()
        showPost(postIdToShow.value)
      }
    }
  }

  const postRespond = (post: Post) => {
    refreshInitTime()
  }

  const createdPostUp = () => {
    if (
      [
        ActivePostPage.Best,
        ActivePostPage.Show,
        ActivePostPage.Oldest,
      ].includes(activePage.value)
    ) {
      if (lastSavedPost.value) {
        showLastSavedPost.value = true
      }
    }
    if ([ActivePostPage.Newest].includes(activePage.value)) {
      if (lastSavedPost.value) {
        const { addPostToTree } = usePostList()

        addPostToTree(lastSavedPost.value as Post)
      }
    }
    refreshInitTime()
  }

  return {
    createdPostBottom,
    createdPostUp,
    showAfterCreate,
    postRespond,
  }
}
